import React, { useContext, useEffect, useState } from "react";
import Select from "react-select";
import { useHistory } from "react-router";

import { Menu } from "../Menu";
import { MenuLateral } from "../MenuLateral";
import { AppContext } from "../../../../Context/Context";

import { ModalAviso } from "./ModalAviso";
import * as bodyScrollLock from "body-scroll-lock";
const disableBodyScroll = bodyScrollLock.disableBodyScroll;
const enableBodyScroll = bodyScrollLock.enableBodyScroll;

const options = [
    { value: ["Impaga", "Emitida"], label: "Emitidas e Impagas" },
    { value: "Todos", label: "Todos" },
    { value: "Cancelada", label: "Cancelada" },
    { value: "Emitida", label: "Emitida" },
    { value: "Impaga", label: "Impaga" },
    { value: "Licitada", label: "Licitada" },
    { value: "Paga", label: "Paga" },
    { value: "Paga Fuera de Término", label: "Paga Fuera de Término" },
    { value: "Sin Emitir", label: "Sin Emitir" }
];

const colourStyles = {
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
        const color = "#ff1430";
        return {
            ...styles,
            backgroundColor: isDisabled
                ? null
                : isSelected
                    ? data.color
                    : isFocused
                        ? color
                        : null,
            color: isDisabled ? "#ccc" : isSelected ? "#D1D1D1" : isFocused ? "#fff" : data.color,
            cursor: isDisabled ? "not-allowed" : "default",

            ":active": {
                ...styles[":active"],
                backgroundColor:
                    !isDisabled && (isSelected ? data.color : color)
            }
        };
    }
};

const CUOTAS_PER_PAGE = 10;

export const Cuotas = () => {
    const [state] = useContext(AppContext);
    const [value, setvalue] = useState(["Emitida", " e ", "Impaga"]);
    const id = atob(sessionStorage.getItem("dtpln"));
    const [avisoSelected, setAviso] = useState({});
    const [checkbox, setCheckbox] = useState(true);
    const [visibleCount, setVisibleCount] = useState(CUOTAS_PER_PAGE);
    const history = useHistory();

    let planes = null;
    let plan = null;
    let cuotas = null;

    if (state.data !== null) {
        planes = state.data.Usuario.Datos.Planes.Plan;
        plan = planes.filter(plan => plan.Id === id)[0];
        cuotas = plan.Cuotas.Cuota;
        if (cuotas !== undefined) {
            cuotas = cuotas.sort(function comparar(a, b) {
                return b.Cuota - a.Cuota;
            });
        }
    }

    const fetchStateNotification = async () => {
        const endpoint = await (await fetch('/api/show_endpoints/wsonofftiponotificacion')).json();
        const documento = atob(sessionStorage.getItem("dtdc"));
        fetch(
            `${endpoint.url_base}${endpoint.url_variable}?CUIT=${documento}&TipoNotificacion=AVE&TipoAccion=est`,
            { cache: 'no-cache' }
        )
            .then(response => response.json())
            .then(json => {
                setCheckbox(json.Resultado.ErrorCodigo === "on");
            });
    };

    const setNewStateNotification = async (checked) => {
        const endpoint = await (await fetch('/api/show_endpoints/wsonofftiponotificacion')).json();
        const documento = atob(sessionStorage.getItem("dtdc"));
        const action = checked ? "on" : "off";

        setCheckbox(checked);
        fetch(`${endpoint.url_base}${endpoint.url_variable}?CUIT=${documento}&TipoNotificacion=AVE&TipoAccion=${action}`, {
            cache: 'no-cache'
        });
    };

    const handleCheckbox = (e) => {
        const checked = e.target.checked;
        setNewStateNotification(checked);
    };

    let handleOpen = avisoSelected => {
        setAviso(avisoSelected);
        let backdrop = document.querySelector(".modalAvisoBackdrop");
        backdrop.classList.add("open");

        let form = document.querySelector(".modalAvisoScreen");
        form.classList.add("open");

        const optionsBodyScroll = {
            reserveScrollBarGap: true
        };

        disableBodyScroll(backdrop, optionsBodyScroll);

        //console.log("click");
    };

    let handleClose = () => {
        let backdrop = document.querySelector(".modalAvisoBackdrop");
        backdrop.classList.remove("open");

        let form = document.querySelector(".modalAvisoScreen");
        form.classList.remove("open");
        enableBodyScroll(backdrop);
    };

    const handleImprimir = async (url) => {
        await auditService();
        window.open(url, "_blank", "noopener,noreferrer");
    };

    const handlePagar = (link, name) => {
        sessionStorage.setItem("url", btoa(link));
        localStorage.setItem("cuota_pagar", name);
        history.push("/pagar");
    };

    let handleInputChange = e => {
        setvalue(e.value);
    };

    let cuotasToShow;
    //console.log("value", value);
    //console.log("cuotas", cuotas);
    if (cuotas !== null) {
        if (cuotas !== undefined) {
            cuotas.map(c => {
                /* //console.log(c); */
            });

            if (value != "Todos") {
                cuotasToShow = cuotas.filter(cuota => {
                    if (!value) return false;
                    if (typeof value === "string") {
                        return cuota.Estado == value;
                    } else {
                        return value.some(v => cuota.Estado === v);
                    }
                });
            } else {
                cuotasToShow = cuotas;
            }
        } else {
            cuotasToShow = undefined;
        }
    }

    const auditService = async () => {
        try {
            const auditoriaServicioData = {
                marca: "fiat",
                modo: "PDF",
                tipo_envio: "Descarga cuota",
                codigo_motivo: 4,
                motivo: "Aviso de Vencimiento",
                fecha_hora: new Date().toISOString(),
                cuit_cuil: atob(sessionStorage.getItem("dtdc"))
            };

            let response = await fetch("/api/post_auditoria_servicio", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(auditoriaServicioData)
            });

            response = await response.json();

            if (!response.success) {
                console.error("Error auditoría:", response);
            }
        } catch (err) {
            console.error("Error auditoría:", err);
        }
    };

    // Reset visible count when filter changes
    useEffect(() => {
        setVisibleCount(CUOTAS_PER_PAGE);
    }, [value]);

    const handleVerMas = () => {
        setVisibleCount(prev => prev + CUOTAS_PER_PAGE);
    };

    return (
        <>
            <div>
                <Menu />
                <div className="wrap">
                    <MenuLateral key={state.selectedPlan?.Id || "default-key"} />
                    <div className="next-to-sidebar">
                        {planes !== null ? (
                            <div className="cuotas">
                                <div className="cuotas_mainDiv mt-dbhf">
                                    <div className="cuotas_mainDiv--user">
                                        <p>Cuotas</p>
                                        <div className="separator--hor mt-half mb-half"></div>
                                    </div>
                                    <div className="cuotas_mainDiv--resumen">
                                        <p className="cuotas_mainDiv--resumen--title">
                                            Resumen
                                        </p>
                                        <div style={{ display: "flex" }}>
                                            <div className="cuotas_mainDiv--resumen--texts">
                                                <div className="cuotas_mainDiv--resumen--texts--text">
                                                    <p>Pagadas : {plan.Resumen.Pagas}</p>
                                                    <p>
                                                        Canceladas:{" "}
                                                        {plan.Resumen.Canceladas}
                                                    </p>
                                                    <p>
                                                        Licitadas : {plan.Resumen.Licitadas}
                                                    </p>
                                                </div>
                                                <div className="cuotas_mainDiv--resumen--texts--text">
                                                    <p>Impagas : {plan.Resumen.Impagas}</p>
                                                    <p>Emitidas: {plan.Resumen.Emitidas}</p>
                                                    <p>
                                                        Sin Emitir: {plan.Resumen.AVencer}
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="datos_mainDiv--alerta">
                                                <p className="datos_mainDiv--alerta--title">
                                                    Envio por email
                                                    {/* {checkbox ? "true" : "false"} */}
                                                </p>
                                                <div>
                                                    <p>Aviso de vencimiento</p>
                                                    <label className="content-input">
                                                        <input
                                                            type="checkbox"
                                                            id="cbox"
                                                            value="checkbox"
                                                            defaultChecked={checkbox}
                                                            onClick={handleCheckbox}
                                                        />
                                                        <i></i>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="cuotas_mainDiv--resumen--boxes">
                                            <p>
                                                Pueden existir pagos que no esten aún
                                                reflejados en este estado de cuenta.
                                            </p>
                                            <div className="cuotas_mainDiv--resumen--boxes--texts">
                                                <div className="cuotas_mainDiv--resumen--boxes--texts--text">
                                                    <p>
                                                        <b>Pagas: </b>cuotas abonadas
                                                        por el cliente.
                                                    </p>
                                                    <p>
                                                        <b>Canceladas:</b> cuotas
                                                        abonadas por el cliente antes de
                                                        su emisión.
                                                    </p>
                                                    <p>
                                                        <b>Licitadas:</b> cuotas
                                                        canceladas por el pago de una
                                                        licitación.
                                                    </p>
                                                </div>
                                                <div className="cuotas_mainDiv--resumen--boxes--texts--text">
                                                    <p>
                                                        <b>Impagas:</b> cuotas ya
                                                        emitidas y vencidas, no abonadas
                                                        por el cliente.
                                                    </p>
                                                    <p>
                                                        <b>Emitidas:</b> cuotas no
                                                        abonadas que aún no están
                                                        vencidas.
                                                    </p>
                                                    <p>
                                                        <b>Sin Emitir:</b> cuotas aún no
                                                        emitidas.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="separator--hor mt-base mb-half"></div>
                                    </div>
                                    <div className="cuotas_mainDiv--detalle">
                                        <div className="cuotas_mainDiv--detalle--title">
                                            DETALLE
                                        </div>
                                        <div className="cuotas_mainDiv--detalle--descripcion">
                                            Estado de cuota
                                        </div>
                                        <div className="cuotas_mainDiv--detalle--select">
                                            <Select
                                                styles={colourStyles}
                                                options={options}
                                                theme={theme => ({
                                                    ...theme,
                                                    borderRadius: 0,
                                                    colors: {
                                                        ...theme.colors,
                                                        primary25: "#ff1430",
                                                        primary: "#D1D1D1"
                                                    }
                                                })}
                                                placeholder={value}
                                                onChange={handleInputChange}
                                            />
                                        </div>
                                    </div>
                                    {cuotasToShow !== null ? (
                                        cuotasToShow !== undefined ? (
                                            cuotasToShow.length > 0 ? (
                                            <div className="cuotas_mainDiv--desplegables">
                                                <div className="cuotas-table-wrapper">
                                                    <table className="cuotas-table">
                                                        <thead>
                                                            <tr>
                                                                <th>Cuota</th>
                                                                <th>Monto</th>
                                                                <th>Vencimiento</th>
                                                                <th>Estado</th>
                                                                <th>Acciones</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {cuotasToShow
                                                                .slice(0, visibleCount)
                                                                .map(cuota => {
                                                                    const isPaga = cuota.Estado === "Paga" || cuota.Estado === "Paga Fuera de Término";
                                                                    const isImpaga = cuota.Estado === "Impaga";
                                                                    return (
                                                                        <tr key={cuota.Cuota}>
                                                                            <td>{cuota.Cuota}</td>
                                                                            <td>$ {Number(cuota.Importe).toLocaleString("de-DE")}</td>
                                                                            <td>{cuota.Vencimiento}</td>
                                                                            <td className={isPaga ? "estado-paga" : isImpaga ? "estado-impaga" : ""}>
                                                                                {cuota.Estado}
                                                                                {isPaga && cuota.Pago && (
                                                                                    <span className="fecha-pago"> (PAGADA {cuota.Pago})</span>
                                                                                )}
                                                                            </td>
                                                                            <td className="acciones-cell">
                                                                                {Object.keys(cuota.AvisoVecimiento || {}).length > 0 && (
                                                                                    <button
                                                                                        className="btn-imprimir-pdf"
                                                                                        onClick={() => handleOpen(cuota.AvisoVecimiento)}
                                                                                    >
                                                                                        Descargar cuota
                                                                                    </button>
                                                                                )}
                                                                                {cuota.LinkPago && cuota.LinkPago.length > 0 && (
                                                                                    <a
                                                                                        className="btn-pagar"
                                                                                        href={cuota.LinkPago}
                                                                                        target="_blank"
                                                                                        rel="noopener noreferrer"
                                                                                    >
                                                                                        Pagar
                                                                                    </a>
                                                                                )}
                                                                            </td>
                                                                        </tr>
                                                                    );
                                                                })}
                                                        </tbody>
                                                    </table>
                                                </div>
                                                {visibleCount < cuotasToShow.length && (
                                                    <button
                                                        className="btn-ver-mas-cuotas"
                                                        onClick={handleVerMas}
                                                    >
                                                        Ver más cuotas
                                                    </button>
                                                )}
                                            </div>
                                            ) : (
                                                <p>No existen cuotas con el estado seleccionado</p>
                                            )
                                        ) : (
                                            <div className="cuotas_mainDiv--noCuotas">
                                                No existen cuotas para este plan.
                                            </div>
                                        )
                                    ) : (
                                        <div className="spinner-loader">
                                            <div
                                                className="spinner-border text-warning mt-dbhf mb-doub align-self-center"
                                                role="status"
                                            >
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        ) : (
                            <div className="spinner-loader w-100 d-flex justify-content-center">
                                <div
                                    className="spinner-border text-rojo text-warning mt-dbhf mb-doub align-self-center"
                                    role="status"
                                >
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
            <ModalAviso handleClose={handleClose}>
                <div className="modalContainer">
                    {Object.keys(avisoSelected).length > 0 &&
                        avisoSelected.Aviso.map(campo =>
                            campo.Etiqueta !== "Imprimir" ? (
                                campo.Etiqueta == "Grupo/Orden:" ||
                                    campo.Etiqueta == "Vencimiento:" ||
                                    campo.Etiqueta == "Comprobante:" ? (
                                    <div>
                                        <b>{campo.Etiqueta} </b>
                                        {campo.Valor}
                                    </div>
                                ) : (
                                    <div>
                                        <b>{campo.Etiqueta}</b>
                                        {" $ " +
                                            Number(campo.Valor).toLocaleString(
                                                "de-DE"
                                            )}
                                    </div>
                                )
                            ) : (
                                <button
                                    type="button"
                                    className="buttonModalMob"
                                    onClick={() => handleImprimir(campo.Valor)}
                                >
                                    <span>Imprimir</span>
                                </button>
                            )
                        )}
                </div>
            </ModalAviso>
        </>
    );
};

// import React, { useEffect, useState } from 'react';
// import Select from 'react-select'
// import { makeStyles } from '@material-ui/core/styles';

// import { Menu } from '../Menu'
// import { AccordionCuotas } from './AccordionCuotas';
// import { CuotasVerMas } from '../../../../functionalities/CuotasVerMas';

// const useStyles = makeStyles((theme) => ({
//     root: {
//         width: '100%',
//         border: 'none',
//     },
//     heading: {
//         fontSize: theme.typography.pxToRem(15),
//         fontWeight: theme.typography.fontWeightRegular,
//     },
// }));

// let cuotas = [
//     {
//         "Cuota": "1",
//         "Tag": "Fuera de término",
//         "Estado": "Ahorro",
//         "Vencimiento": "10/11/2016",
//         "Pago": "05/11/2016",
//         "Importe": "222222",
//         "AvisoVencimiento": "",
//         "LinkPago": ""
//     },
//     {
//         "Cuota": "2",
//         "Tag": "Fuera de término",
//         "Estado": "Paga",
//         "Vencimiento": "10/11/2016",
//         "Importe": "222222",
//         "Pago": "05/11/2016",
//         "AvisoVencimiento": "",
//         "LinkPago": ""
//     },
//     {
//         "Cuota": "3",
//         "Tag": "Fuera de término",
//         "Estado": "Paga",
//         "Vencimiento": "10/11/2016",
//         "Pago": "05/11/2016",
//         "Importe": "222222",
//         "AvisoVencimiento": "",
//         "LinkPago": ""
//     },
//     {
//         "Cuota": "4",
//         "Tag": "Fuera de término",
//         "Estado": "Paga",
//         "Vencimiento": "10/11/2016",
//         "Pago": "05/11/2016",
//         "Importe": "222222",
//         "AvisoVencimiento": "",
//         "LinkPago": ""
//     },
//     {
//         "Cuota": "5",
//         "Tag": "Fuera de término",
//         "Estado": "Paga",
//         "Vencimiento": "10/11/2016",
//         "Pago": "05/11/2016",
//         "Importe": "222222",
//         "AvisoVencimiento": "",
//         "LinkPago": ""
//     },
//     {
//         "Cuota": "6",
//         "Tag": "Fuera de término",
//         "Estado": "Paga",
//         "Vencimiento": "10/11/2016",
//         "Pago": "05/11/2016",
//         "Importe": "222222",
//         "AvisoVencimiento": "",
//         "LinkPago": ""
//     },
//     {
//         "Cuota": "7",
//         "Tag": "Fuera de término",
//         "Estado": "Ahorro",
//         "Vencimiento": "10/11/2016",
//         "Pago": "05/11/2016",
//         "Importe": "222222",
//         "AvisoVencimiento": "",
//         "LinkPago": ""
//     },
//     {
//         "Cuota": "8",
//         "Tag": "Fuera de término",
//         "Estado": "Ahorro",
//         "Vencimiento": "10/11/2016",
//         "Pago": "05/11/2016",
//         "Importe": "222222",
//         "AvisoVencimiento": "",
//         "LinkPago": ""
//     },
//     {
//         "Cuota": "9",
//         "Tag": "Fuera de término",
//         "Estado": "Ahorro",
//         "Vencimiento": "10/11/2016",
//         "Pago": "05/11/2016",
//         "Importe": "222222",
//         "AvisoVencimiento": "",
//         "LinkPago": ""
//     },
//     ,
//     {
//         "Cuota": "10",
//         "Tag": "Fuera de término",
//         "Estado": "Ahorro",
//         "Vencimiento": "10/11/2016",
//         "Pago": "05/11/2016",
//         "Importe": "222222",
//         "AvisoVencimiento": "",
//         "LinkPago": ""
//     },
//     {
//         "Cuota": "11",
//         "Tag": "Fuera de término",
//         "Estado": "Ahorro",
//         "Vencimiento": "10/11/2016",
//         "Pago": "05/11/2016",
//         "Importe": "222222",
//         "AvisoVencimiento": "",
//         "LinkPago": ""
//     },
//     {
//         "Cuota": "12",
//         "Tag": "Fuera de término",
//         "Estado": "Paga",
//         "Vencimiento": "10/11/2016",
//         "Importe": "222222",
//         "Pago": "05/11/2016",
//         "AvisoVencimiento": "",
//         "LinkPago": ""
//     },
//     {
//         "Cuota": "13",
//         "Tag": "Fuera de término",
//         "Estado": "Paga",
//         "Vencimiento": "10/11/2016",
//         "Pago": "05/11/2016",
//         "Importe": "222222",
//         "AvisoVencimiento": "",
//         "LinkPago": ""
//     },
//     {
//         "Cuota": "14",
//         "Tag": "Fuera de término",
//         "Estado": "Paga",
//         "Vencimiento": "10/11/2016",
//         "Pago": "05/11/2016",
//         "Importe": "222222",
//         "AvisoVencimiento": "",
//         "LinkPago": ""
//     },
//     {
//         "Cuota": "15",
//         "Tag": "Fuera de término",
//         "Estado": "Paga",
//         "Vencimiento": "10/11/2016",
//         "Pago": "05/11/2016",
//         "Importe": "222222",
//         "AvisoVencimiento": "",
//         "LinkPago": ""
//     },
//     {
//         "Cuota": "16",
//         "Tag": "Fuera de término",
//         "Estado": "Paga",
//         "Vencimiento": "10/11/2016",
//         "Pago": "05/11/2016",
//         "Importe": "222222",
//         "AvisoVencimiento": "",
//         "LinkPago": ""
//     },
//     {
//         "Cuota": "17",
//         "Tag": "Fuera de término",
//         "Estado": "Ahorro",
//         "Vencimiento": "10/11/2016",
//         "Pago": "05/11/2016",
//         "Importe": "222222",
//         "AvisoVencimiento": "",
//         "LinkPago": ""
//     },
//     {
//         "Cuota": "18",
//         "Tag": "Fuera de término",
//         "Estado": "Paga",
//         "Vencimiento": "10/11/2016",
//         "Pago": "05/11/2016",
//         "Importe": "222222",
//         "AvisoVencimiento": "",
//         "LinkPago": ""
//     },
//     {
//         "Cuota": "19",
//         "Tag": "Fuera de término",
//         "Estado": "Paga",
//         "Vencimiento": "10/11/2016",
//         "Pago": "05/11/2016",
//         "Importe": "222222",
//         "AvisoVencimiento": "",
//         "LinkPago": ""
//     },
//     ,
//     {
//         "Cuota": "20",
//         "Tag": "Fuera de término",
//         "Estado": "Paga",
//         "Vencimiento": "10/11/2016",
//         "Pago": "05/11/2016",
//         "Importe": "222222",
//         "AvisoVencimiento": "",
//         "LinkPago": ""
//     },
//     {
//         "Cuota": "21",
//         "Tag": "Fuera de término",
//         "Estado": "Ahorro",
//         "Vencimiento": "10/11/2016",
//         "Pago": "05/11/2016",
//         "Importe": "222222",
//         "AvisoVencimiento": "",
//         "LinkPago": ""
//     },
//     {
//         "Cuota": "22",
//         "Tag": "Fuera de término",
//         "Estado": "Ahorro",
//         "Vencimiento": "10/11/2016",
//         "Pago": "05/11/2016",
//         "Importe": "222222",
//         "AvisoVencimiento": "",
//         "LinkPago": ""
//     },
//     {
//         "Cuota": "23",
//         "Tag": "Fuera de término",
//         "Estado": "Ahorro",
//         "Vencimiento": "10/11/2016",
//         "Pago": "05/11/2016",
//         "Importe": "222222",
//         "AvisoVencimiento": "",
//         "LinkPago": ""
//     },
//     {
//         "Cuota": "24",
//         "Tag": "Fuera de término",
//         "Estado": "Otro",
//         "Vencimiento": "10/11/2016",
//         "Pago": "05/11/2016",
//         "Importe": "222222",
//         "AvisoVencimiento": "",
//         "LinkPago": ""
//     },
//     {
//         "Cuota": "25",
//         "Tag": "Fuera de término",
//         "Estado": "Otro",
//         "Vencimiento": "10/11/2016",
//         "Pago": "05/11/2016",
//         "Importe": "222222",
//         "AvisoVencimiento": "",
//         "LinkPago": ""
//     },
//     {
//         "Cuota": "26",
//         "Tag": "Fuera de término",
//         "Estado": "Otro",
//         "Vencimiento": "10/11/2016",
//         "Pago": "05/11/2016",
//         "Importe": "222222",
//         "AvisoVencimiento": "",
//         "LinkPago": ""
//     },
//     {
//         "Cuota": "27",
//         "Tag": "Fuera de término",
//         "Estado": "Ahorro",
//         "Vencimiento": "10/11/2016",
//         "Pago": "05/11/2016",
//         "Importe": "222222",
//         "AvisoVencimiento": "",
//         "LinkPago": ""
//     },
//     {
//         "Cuota": "28",
//         "Tag": "Fuera de término",
//         "Estado": "Ahorro",
//         "Vencimiento": "10/11/2016",
//         "Pago": "05/11/2016",
//         "Importe": "222222",
//         "AvisoVencimiento": "",
//         "LinkPago": ""
//     },
//     {
//         "Cuota": "29",
//         "Tag": "Fuera de término",
//         "Estado": "Ahorro",
//         "Vencimiento": "10/11/2016",
//         "Pago": "05/11/2016",
//         "Importe": "222222",
//         "AvisoVencimiento": "",
//         "LinkPago": ""
//     },
//     {
//         "Cuota": "30",
//         "Tag": "Fuera de término",
//         "Estado": "Otro",
//         "Vencimiento": "10/11/2016",
//         "Pago": "05/11/2016",
//         "Importe": "222222",
//         "AvisoVencimiento": "",
//         "LinkPago": ""
//     },
//     {
//         "Cuota": "31",
//         "Tag": "Fuera de término",
//         "Estado": "Otro",
//         "Vencimiento": "10/11/2016",
//         "Pago": "05/11/2016",
//         "Importe": "222222",
//         "AvisoVencimiento": "",
//         "LinkPago": ""
//     },
//     {
//         "Cuota": "32",
//         "Tag": "Fuera de término",
//         "Estado": "Otro",
//         "Vencimiento": "10/11/2016",
//         "Pago": "05/11/2016",
//         "Importe": "222222",
//         "AvisoVencimiento": "",
//         "LinkPago": ""
//     },
//     {
//         "Cuota": "33",
//         "Tag": "Fuera de término",
//         "Estado": "Otro",
//         "Vencimiento": "10/11/2016",
//         "Pago": "05/11/2016",
//         "Importe": "222222",
//         "AvisoVencimiento": "",
//         "LinkPago": ""
//     },
//     {
//         "Cuota": "34",
//         "Tag": "Fuera de término",
//         "Estado": "Otro",
//         "Vencimiento": "10/11/2016",
//         "Pago": "05/11/2016",
//         "Importe": "222222",
//         "AvisoVencimiento": "",
//         "LinkPago": ""
//     },
//     {
//         "Cuota": "35",
//         "Tag": "Fuera de término",
//         "Estado": "Otro",
//         "Vencimiento": "10/11/2016",
//         "Pago": "05/11/2016",
//         "Importe": "222222",
//         "AvisoVencimiento": "",
//         "LinkPago": ""
//     },
//     {
//         "Cuota": "36",
//         "Tag": "Fuera de término",
//         "Estado": "Otro",
//         "Vencimiento": "10/11/2016",
//         "Pago": "05/11/2016",
//         "Importe": "222222",
//         "AvisoVencimiento": "",
//         "LinkPago": ""
//     },
//     {
//         "Cuota": "37",
//         "Tag": "Fuera de término",
//         "Estado": "Otro",
//         "Vencimiento": "10/11/2016",
//         "Pago": "05/11/2016",
//         "Importe": "222222",
//         "AvisoVencimiento": "",
//         "LinkPago": ""
//     },
//     {
//         "Cuota": "38",
//         "Tag": "Fuera de término",
//         "Estado": "Otro",
//         "Vencimiento": "10/11/2016",
//         "Pago": "05/11/2016",
//         "Importe": "222222",
//         "AvisoVencimiento": "",
//         "LinkPago": ""
//     },
//     {
//         "Cuota": "39",
//         "Tag": "Fuera de término",
//         "Estado": "Ahorro",
//         "Vencimiento": "10/11/2016",
//         "Pago": "05/11/2016",
//         "Importe": "222222",
//         "AvisoVencimiento": "",
//         "LinkPago": ""
//     },
//     {
//         "Cuota": "40",
//         "Tag": "Fuera de término",
//         "Estado": "Ahorro",
//         "Vencimiento": "10/11/2016",
//         "Pago": "05/11/2016",
//         "Importe": "222222",
//         "AvisoVencimiento": "",
//         "LinkPago": ""
//     },

// ]

// cuotas = cuotas.sort(function comparar(a, b) { return b.Cuota - a.Cuota; })

// const options = [
//     { value: 'Todos', label: 'Todos' },
//     { value: 'Ahorro', label: 'Ahorro' },
//     { value: 'Otro', label: 'Otro' }
// ]

// const colourStyles = {
//     option: (styles, { data, isDisabled, isFocused, isSelected }) => {
//         const color = '#A21C41';
//         return {
//             ...styles,
//             backgroundColor: isDisabled
//                 ? null
//                 : isSelected
//                     ? data.color
//                     : isFocused
//                         ? color
//                         : null,
//             color: isDisabled
//                 ? '#000'
//                 : isSelected
//                     ? '#000'
//                     : isFocused ? '#fff': '#000',

//             cursor: isDisabled ? 'not-allowed' : 'default',

//             ':active': {
//                 ...styles[':active'],
//                 backgroundColor:
//                     !isDisabled && (isSelected ? data.color : color),
//             },
//         };
//     },
// };

// export const Cuotas = () => {
//     const classes = useStyles();
//     const [value, setvalue] = useState('Todos');

//     useEffect(() => {

//         new CuotasVerMas('#cuotas')
//         let buttonVerMas = document.getElementById('verMasCuotas');
//         let cuotasHidden = document.querySelectorAll('.hideItem');
//         //console.log(cuotasHidden);
//         if (cuotasHidden.length < 3) {
//             buttonVerMas.style.display = 'none';
//         } else {
//             buttonVerMas.style.display = 'block'
//         }
//     }, [value])

//     useEffect(() => {
//         let buttonVerMas = document.getElementById('verMasCuotas');

//         buttonVerMas.addEventListener('click', () => {
//             let cuotasHidden = document.querySelectorAll('.hideItem');
//             if (cuotasHidden.length < 4) {
//                 buttonVerMas.style.display = 'none';
//             }
//             if (cuotasHidden.length > 0) {
//                 for (let index = 0; index < 3; index++) {
//                     //console.log(cuotasHidden[index]);
//                     cuotasHidden[index].classList.remove('hideItem');
//                     cuotasHidden[index].classList.add('showItem');
//                 }
//             }
//         });

//     }, [])

//     let handleInputChange = (e) => {
//         setvalue(e.value);
//     }

//     let cuotasToShow;
//     if (value != 'Todos') {
//         cuotasToShow = cuotas.filter(cuota => cuota.Estado == value)
//     } else {
//         cuotasToShow = cuotas;
//     }

//     return (
//         <div>
//             <Menu />
//             <div className="cuotas">
//                 <div className="cuotas_mainDiv mt-dbhf">
//                     <div className="cuotas_mainDiv--user">
//                         <p>Cuotas</p>
//                         <div className="separator--hor mt-half mb-half"></div>
//                     </div>
//                     <div className="cuotas_mainDiv--plan">
//                         <p>PLAN 84 cuotas Renegade SPORT 1.8 MT5 </p>

//                         <div className="separator--hor mt-base mb-half"></div>
//                     </div>
//                     <div className="cuotas_mainDiv--resumen">
//                         <p className="cuotas_mainDiv--resumen--title">Resumen</p>
//                         <div className="cuotas_mainDiv--resumen--texts">
//                             <div className="cuotas_mainDiv--resumen--texts--text">
//                                 <p>Pagadas : 29</p>
//                                 <p>Canceladas: 55</p>
//                                 <p>Licitadas : 0</p>
//                             </div>
//                             <div className="cuotas_mainDiv--resumen--texts--text">
//                                 <p>Impagas : 29</p>
//                                 <p>Emitidas: 55</p>
//                                 <p>A vencer : 0</p>
//                             </div>
//                         </div>
//                         <div className="cuotas_mainDiv--resumen--boxes">
//                             <p>Pueden existir pagos que no esten aún reflejados en este estado de cuenta.</p>
//                             <div className="cuotas_mainDiv--resumen--boxes--texts">
//                                 <div className="cuotas_mainDiv--resumen--boxes--texts--text">
//                                     <p><b>Pagas: </b>cuotas abonadas por el cliente.</p>
//                                     <p><b>Canceladas:</b> cuotas abonadas por el cliente antes de su emisión.</p>
//                                     <p><b>Licitadas:</b> cuotas canceladas por el pago de una licitación.</p>
//                                 </div>
//                                 <div className="cuotas_mainDiv--resumen--boxes--texts--text">
//                                     <p><b>Impagas:</b> cuotas ya emitidas y vencidas, no abonadas por el cliente.</p>
//                                     <p><b>Emitidas:</b> cuotas no abonadas que aún no están vencidas.</p>
//                                     <p><b>A vencer:</b> cuotas aún no emitidas.</p>
//                                 </div>
//                             </div>
//                         </div>

//                         <div className="separator--hor mt-base mb-half"></div>
//                     </div>
//                     <div className="cuotas_mainDiv--detalle">
//                         <div className="cuotas_mainDiv--detalle--title">DETALLE</div>
//                         <div className="cuotas_mainDiv--detalle--descripcion">Estado de cuota</div>
//                         <div className="cuotas_mainDiv--detalle--select">
//                             <Select
//                                 styles={colourStyles}
//                                 options={options}
//                                 theme={theme => ({
//                                     ...theme,
//                                     borderRadius: 0,
//                                     colors: {
//                                         ...theme.colors,
//                                         primary25: '#A21C41',
//                                         primary: '#D1D1D1',
//                                     },
//                                 })}
//                                 placeholder={value}
//                                 onChange={handleInputChange} />
//                         </div>
//                     </div>
//                     <div className="cuotas_mainDiv--desplegables">
//                         <div className={classes.root}>
//                             {cuotasToShow.map(cuota => (
//                                 <AccordionCuotas key={cuota.Cuota} name={cuota.Cuota} />
//                             ))}
//                         </div>
//                         <button id="verMasCuotas">Ver más</button>
//                     </div>

//                 </div>
//             </div>
//         </div>
//     )
// }
